// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Z59mM","list":"BalanceDue_list__2hkvA","listRow":"BalanceDue_listRow__QnNfP","total":"BalanceDue_total__tHtVu"};